module.exports = __webpack_public_path__ + "static/media/diet.382beeed.svg";